import heroBackdrop from "@/assets/hero-landing.jpg";

/**
 * Premium hero backdrop. Layers a high-fidelity brand image (generated via
 * the Lovable AI image pipeline) with animated radial blobs for depth and
 * motion. Auto-disables animation when prefers-reduced-motion is set.
 */
export function HeroMesh({ className = "" }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    >
      {/* Brand image base layer */}
      <img
        src={heroBackdrop}
        alt=""
        aria-hidden
        className="absolute inset-0 h-full w-full object-cover opacity-80 mix-blend-screen dark:opacity-60"
        loading="eager"
        decoding="async"
      />
      {/* Tonal overlay to keep text contrast */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, hsl(var(--background) / 0.10) 0%, hsl(var(--background) / 0.55) 70%, hsl(var(--background)) 100%)",
        }}
      />
      {/* Animated brand blobs for motion */}
      <div
        className="absolute -top-1/4 -left-1/4 h-[60vh] w-[60vw] rounded-full opacity-50 blur-3xl motion-safe:animate-mesh-a"
        style={{ background: "radial-gradient(closest-side, hsl(var(--primary) / 0.45), transparent 70%)" }}
      />
      <div
        className="absolute top-1/3 -right-1/4 h-[55vh] w-[55vw] rounded-full opacity-45 blur-3xl motion-safe:animate-mesh-b"
        style={{ background: "radial-gradient(closest-side, hsl(var(--accent) / 0.42), transparent 70%)" }}
      />
    </div>
  );
}
